import "./styles.scss"

export const ScalePillDescription = ({ color = "red", label, customColor }) => {
  return (
    <div className="esm-pill">
      <div
        className={`esm-pill-colors esm-pill-colors--${color}`}
        style={customColor && { backgroundColor: customColor }}
      />
      <span>{label}</span>
    </div>
  )
}